import styled from "styled-components";

export const ModalContainer = styled.div`
    padding: 8px 0;
    text-align: center;
`;

export const ConfirmationText = styled.p`
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    font-weight: 400;
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
`;

export const ConfirmationButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
`;

export const CancelButton = styled.button`
    padding: 10px 24px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    color: #666;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        border-color: #aef001;
        color: #333;
    }
`;

export const ConfirmButton = styled.button`
    padding: 10px 24px;
    border: none;
    border-radius: 6px;
    background: ${props => (props.disabled ? "#d3d3d3" : "#aef001")};
    color: ${props => (props.disabled ? "#999" : "#333")};
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
    min-width: 100px;

    &:hover:not(:disabled) {
        background: #9dd401;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(174, 240, 1, 0.3);
    }
`;

export const ModalStyle = {
    borderRadius: "10px"
};

export const ModalBodyStyle = {
    padding: "24px",
    borderRadius: "10px"
};
